require('ta-semantic-ui/semantic/dist/components/reset.css');
require('ta-semantic-ui/semantic/dist/components/site.css');
require('ta-semantic-ui/semantic/dist/components/divider.css');
require('styles/App.css');

import React from 'react';
import Polls from '../polls/Polls';
import ModelComparison from '../modelComparison/ModelComparison';
import Statistics from '../statistics/Statistics';
import Electors from '../electors/Electors';
import Battlestates from '../battlestates/Battlestates';

class AppComponent extends React.Component {

  render() {
    return (
        <div id="wrapper">
          <div className="ui vertical segment">
            <Polls />
          </div>
          <div className="ui vertical segment">
            <Electors />
          </div>
          <div className="ui vertical segment">
            <Battlestates />
          </div>
          <div className="ui vertical segment">
            <ModelComparison />
          </div>
          <small>Interaktiv-Team, «Tages-Anzeiger»</small>
          <Statistics projectId='us-election-monitor'/>
        </div>
    );
  }
}

AppComponent.defaultProps = {};

export default AppComponent;



/** WEBPACK FOOTER **
 ** ./src/components/main/Main.js
 **/